import {
  getQueryMetadataStudiesStudyIdQueriesMetadataGet,
  GetQueryMetadataStudiesStudyIdQueriesMetadataGetResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import studyQueryKeys from './queryKeyFactory'

export type QueryMetadataParams = {
  study_id: string
  site_id?: string
  qc_task_id?: string
  subject_id?: string
  timepoint_submission_id?: string
}

export interface UseStudyQueryMetadataOptions {
  enabled?: boolean
}

export function useStudyQueryMetadata(
  params: QueryMetadataParams,
  options: UseStudyQueryMetadataOptions = {},
): UseQueryResult<GetQueryMetadataStudiesStudyIdQueriesMetadataGetResponse, AxiosError<HTTPValidationError>> {
  return useQuery({
    queryKey: studyQueryKeys.metadata(
      params.study_id,
      params.qc_task_id ?? '',
      params.site_id ?? '',
      params.subject_id ?? '',
      params.timepoint_submission_id ?? '',
    ),
    queryFn: async () => {
      const response = await getQueryMetadataStudiesStudyIdQueriesMetadataGet({
        path: { study_id: params.study_id },
        query: {
          qc_task_id: params.qc_task_id,
          site_id: params.site_id,
          subject_id: params.subject_id,
          timepoint_submission_id: params.timepoint_submission_id,
        },
        throwOnError: true,
      })
      return response.data
    },
    enabled: options.enabled ?? true,
  })
}
